module.exports = __webpack_public_path__ + "static/media/ht_stay_Set.58c97aed.webp";